module.exports = __webpack_public_path__ + "static/hwt-5b0823b963ac997eb04522fb57ba6f5d.jpg";